module.exports = __webpack_public_path__ + "media/images/meta/purebarre/favicon-7fd867cc9c09bc75ee565b281d781cf9.png";